import { createSelector } from 'reselect'
import getHasSampledProductDataSelector from 'modules/product/redux/selectors/get-has-sampled-product-data'
import getSelectedVariantIdUtil from 'containers/ProductCollection/components/Item/redux/selectors/get-selected-variant-id/utils'

const getSelectedVariantIdSelector = ({
  productVariantSample,
  shouldShowFullSizeConversion
}) => createSelector(
  getHasSampledProductDataSelector(productVariantSample?.product_id),
  (sampledData) => {
    return getSelectedVariantIdUtil({
      productVariantSample,
      sampledData,
      shouldShowFullSizeConversion
    })
  }
)
export default getSelectedVariantIdSelector
